import React, { useContext, useState } from 'react';
import { withRouter } from 'react-router-dom';
import { FormattedMessage, injectIntl } from 'react-intl';

import { PrimaryButton } from '@xingternal/malt-button';
import Textlink from '@xingternal/malt-textlink';

import LockImage from './../../../Components/Illustrations/LockImage';
import PageviewTracker from './../../../Components/PageviewTracker/PageviewTracker';
import { CustomH, CustomP } from './../../../Components/CustomMalt/Typography';

import api from '../../../utils/api';

import Store from '../../../store';

import styles from './styles.css';
import messages from './messages';

const PasswordUpdateEidi = ({ toLogin, email, history: { push }, intl }) => {
  const [isLoading, setIsLoading] = useState(false);
  const context = useContext(Store);

  const handleClick = e => {
    e.preventDefault();
    setIsLoading(true);

    api
      .post('/recovery/password/reset_requests')
      .then(() => {
        context.dispatch({
          type: 'SET_USERNAME',
          payload: { username: email },
        });
        push('/recovery/password/confirm');
      })
      .catch(err => {
        console.error(err);

        setIsLoading(false);
        toLogin();
      });
  };

  return (
    <React.Fragment>
      <PageviewTracker pageName={'wbm/Welcome/login/account/password_reset'} />
      <LockImage />
      <CustomH>
        <FormattedMessage {...messages.passwordUpdateTitle} />
      </CustomH>
      <CustomP>
        <FormattedMessage {...messages.passwordUpdateEidiParagraph} />
      </CustomP>
      <Textlink
        href={intl.formatMessage(messages.passwordMoreInfoLinkTarget)}
        target="_blank"
      >
        <FormattedMessage {...messages.passwordMoreInfoLinkText} />
      </Textlink>
      <PrimaryButton
        loading={isLoading}
        className={styles.wideButton}
        onClick={handleClick}
      >
        <FormattedMessage {...messages.passwordUpdateButtonText} />
      </PrimaryButton>
    </React.Fragment>
  );
};

export default withRouter(injectIntl(PasswordUpdateEidi));
